import { Banner } from '@diamond/shared/types';

export function nextBannerCreateIndex(banners: Banner): number {
  if (banners.length === 0) {
    return 1;
  }
  return Math.max(...banners.map((banner) => banner.index)) + 1;
}
